import { createGlobalStyle } from 'styled-components';
import theme from '../theme';

export default createGlobalStyle`
  body, input, button {
    font-family: 'Roboto', sans-serif;
    color: ${theme.cores.black};
  }
`;
